import React from 'react'

export const women = (props) => {

    return(
        <div>women Page</div>
    )


}